<template>
  <div class="position-list-wrap">
    <search type="positions"></search>
    <filter-nav type="positions" :tag-list="tagList" :company-list="companyList" :loading="loading"></filter-nav>
    <div v-if="(list && list.length) || loading">
      <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad">
        <position v-for="(item,index) in list" :key="index" :position="item"></position>
      </van-list>
    </div>
    <no-data v-else></no-data>
  </div>
</template>

<script>
  import Search from '@/components/picker/search'
  import FilterNav from '@/components/picker/filterNav'
  import Position from "@/components/position/position";
  import {getPositionList, getPositionTags, getPositionStatistics} from '@/api/positions'
  import NoData from "@/components/noData";
export default {
  name: "positions-module",
  components: {
    NoData,
    Position,
    Search,
    FilterNav
  },
  data() {
    return {
      list: [],
      temp: [],
      loading: false,
      finished: false,
      pageNo: 1,
      pageSize: 10,
      curIds: [],
      tagList: [],
      companyList: []
    };
  },
  methods: {
    onLoad() {
      this.loading = true;
      let params = {pageNo:this.pageNo, pageSize: this.pageSize, ...this.$route.query};

      if(params.companyId && (params.switchOn === 'false' || params.switchOn === false)){
        params.excludeCompanyId = params.companyId;
        params.excludeCompanyId = params.excludeCompanyId.replace(/\|/g, ',');
        delete params.companyId;
      }

      params.positionTagIdsForSearchUnderRange = "279389410249666563"//'463095885486845953'// '279389410249666563';
      getPositionList(params).then(res=>{
        let curIds = [];
        if(res.data && res.data.positionTags){
          res.data.positionTags.forEach(item=>{
            item.positionTagIdsForSearchUnderRange = item.code;
          })
          this.tagList = res.data.positionTags;
        }

        if(res.data&&res.data.companys&&res.data.companys.values&&res.data.companys.values.length){
          this.companyList = res.data.companys.values;
        }

        if(res.data&&res.data.list){
          curIds = res.data.list.map(item=>item.positionId) || [];

          res.data.list.forEach(item=>{
            item.positionTags = [];
            item.statics = {};
          })

          this.list = this.list.concat(res.data.list);

          this.pageNo++;
          if(res.data.list.length < this.pageSize)
            this.finished = true;
        }else{
          this.finished = true;
        }

        if(curIds && curIds.length){
          this.positionTags(curIds);
          this.positionStatistics(curIds);
        }
      }).catch(err=>{}).finally(()=>{this.loading = false;});
    },
    positionTags(curIds){
      getPositionTags({positionIds: curIds.join(',')}).then(res=>{
        this.list.forEach(item=>{
          if(res.data[item.positionId]){
            item.positionTags = res.data[item.positionId];
          }
        })
      }).catch(err=>{})
    },
    positionStatistics(curIds){
      getPositionStatistics({positionIds: curIds.join(',')}).then(res=>{
        this.list.forEach(item=>{
          if(res.data[item.positionId]){
            item.statics = res.data[item.positionId];
          }
        })
      }).catch(err=>{})
    }
  },
  watch: {
    $route(n,o){
      this.list = [];
      this.pageNo = 1;
      this.finished = false;
      this.onLoad();
    }
  },
  created() {
    this.onLoad();
    this.$store.commit('comp/WX_SHARE',{
      title:'猎上新职 - 新发职位、更易成单、速来推人',
      desc:'重新定义人才服务'
    });
  }
};
</script>
<style scoped lang="scss">
  .position-list-wrap{
    height: 100%;
    background-color: #f5f5f5;
  }
</style>
